export const darkenColor = (
  color: string,
  percentage: number = 0.3
): string => {
  const parseColor = (color: string) => {
    let r = 0,
      g = 0,
      b = 0;
    if (color.startsWith("#")) {
      const bigint = parseInt(color.slice(1), 16);
      r = (bigint >> 16) & 255;
      g = (bigint >> 8) & 255;
      b = bigint & 255;
    } else if (color.startsWith("rgb")) {
      const rgbValues = color.match(/\d+/g);
      if (rgbValues) {
        r = parseInt(rgbValues[0]);
        g = parseInt(rgbValues[1]);
        b = parseInt(rgbValues[2]);
      }
    }
    return { r, g, b };
  };

  const { r, g, b } = parseColor(color);

  const darken = (value: number) => Math.round(value * (1 - percentage));

  const toHex = (value: number) => value.toString(16).padStart(2, "0");

  return `#${toHex(darken(r))}${toHex(darken(g))}${toHex(darken(b))}`;
};
